import React, { useState, useEffect, useRef } from 'react';
import VideoPlayer from './Player';
import HtmlVideoPlayer from './Player2';
import VideoPlayer1 from './Player3';
import './player.css';

const App = () => {
  const videoSrc = '/assets/videos/Screen1.mp4';
  const videoSrc1 = '/assets/videos/Screen2.mp4';
  const videoSrc2 = '/assets/videos/Screen3.mp4';
  const front = '/assets/images/First_Page.png';
  const containerRef = useRef(null);
  
  const [currscreen, setcurrscreen] = useState(0);
  const [completed, setCompleted] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isMuted, setIsMuted] = useState(false);

  const audioDescriptions = [
    { startTime: 0, endTime: 5, audioSrc: '/assets/audios/screen01AD.mp3' },
    { startTime: 6, endTime: 10, audioSrc: '/path/to/description2.mp3' },
  ];

  const handleVideoEnd = (screenNumber) => {
    setCompleted((prev) => [...prev, screenNumber]);
  };

  const incrementCount = () => {
    setcurrscreen((prev) => prev + 1);
  };

  const handleFullscreen = () => {
    if (isFullscreen) {
      document.exitFullscreen();
    } else {
      containerRef.current.requestFullscreen();
    }
  };

  const toggleMute = () => {
    setIsMuted((prev) => !prev);
  };

  const handleFullscreenChange = () => {
    setIsFullscreen(!!document.fullscreenElement);
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const Toclink1 = () => setcurrscreen(1);
  const Toclink2 = () => setcurrscreen(2);
  const Toclink3 = () => setcurrscreen(3);

  const decreaseCount = () => {
    setcurrscreen((prev) => prev - 1);
  };

  return (
    <div className='parent-container'>
      <style>
        {`
          @font-face {
            font-family: 'MyCustomFont';
            src: url('/public/assets/Forza-Black.woff') format('woff');
          }
          .Front h1 {
            font-family: MyCustomFont;
          }
            .Front{
            width:100%;
            height:100%}
          @media (orientation: portrait) {
            
          }
          @media (orientation: landscape) {
           
          }
        `}
      </style>
      <div ref={containerRef} className="video-container">
        {currscreen === 0 ? (
         <div className="front">
         <div style={{ position: 'absolute', marginTop: '15%', marginLeft: '3vw', width:'100%' }}>
           <h1 style={{ fontSize: 'clamp(20%, 5vw, 200%)' }}>Using a Clamp Meter</h1>
           <button 
             style={{
               width: 'clamp(15%, 3vw, 100%)', // Responsive button width
               background: '#007ABB',
               color: 'white',
               fontSize: 'clamp(10%, 2vw, 100%)', // Responsive font size
               position: 'absolute',
               padding: '1%' // Responsive padding
             }} 
             onClick={() => setcurrscreen(1)}
           >
             <b>Start Activity</b>
           </button>
         </div>
         <img 
           src={front} 
           className="splash" 
           alt="front page" 
           style={{ 
             maxWidth: '100%', 
             objectFit: 'contain', 
             border: 'clamp(1px, 0.1vw, 3px) solid grey' // Responsive border size
           }} 
         />
       </div>
       
        ) : currscreen === 1 ? (
          <VideoPlayer
            incrementCount={incrementCount}
            decreaseCount={decreaseCount}
            handleFullscreen={handleFullscreen}
            Toclink1={Toclink1}
            Toclink2={Toclink2}
            Toclink3={Toclink3}
            isMuted={isMuted}
            toggleMute={toggleMute}
            completed={completed}
            audioDescriptions={audioDescriptions}
            videoSrc={videoSrc} 
            captions={[
              { startTime: 0, endTime: 5, text: "Let’s explore the clamp meter, a tool that allows for non-invasive current measurement." },
              { startTime: 5, endTime: 13, text: "The clamp is used to encircle a conductor (wire) to measure the current flowing through it without direct contact." },
              { startTime: 13, endTime: 21, text: "The LCD Display shows measurement readings such as current, voltage, resistance, and mode indicators." },
              { startTime: 21, endTime: 30, text: "The + Input Terminal (Positive) is used to connect the positive test lead when measuring parameters like voltage or resistance." },
              { startTime: 30, endTime: 40, text: "The Common or COM Input Terminal (Negative) is the reference point for all measurements and connects the negative test lead." },
              { startTime: 40, endTime: 51, text: "The Function Switch Knob allows the user to select the type of measurement (e.g., AC/DC current, voltage, resistance) and the appropriate range." },
              { startTime: 51, endTime: 59, text: "A technician may choose 100 amps or 400 amps depending upon the current they need to measure." },
              { startTime: 59, endTime: 66, text: "The Clamp Trigger opens and closes the clamp jaws, allowing the user to easily place the clamp around a conductor." },
              { startTime: 66, endTime: 72, text: "Once the jaws are placed around the wire, releasing the trigger allows the current to be measured." },
              { startTime: 72, endTime: 78, text: "On the clamp meter, there is an arrow. This arrow indicates the direction of the current flow. " },
              { startTime: 78, endTime: 87, text: "The meter shows current as either a positive or negative value, depending on the direction of the current flow relative to the clamp." },
              { startTime: 87, endTime: 97, text: "When using the clamp on a positive wire, align the arrow with the current direction. It will show a positive reading, indicating current flows out of the battery." },
              { startTime: 97, endTime: 109, text: "When using the clamp on a negative wire, align the camp arrow with the current flow in the negative wire. It will record a negative reading as the current returns to the battery." },
              { startTime: 109, endTime: 114, text: "Now that you’ve learned about the clamp meter, click the Next button to continue." },
            ]}
            onVideoEnd={() => handleVideoEnd(1)}
          />
        ) : currscreen === 2 ? (
          <HtmlVideoPlayer
            incrementCount={incrementCount}
            decreaseCount={decreaseCount}
            handleFullscreen={handleFullscreen}
            Toclink1={Toclink1}
            Toclink2={Toclink2}
            Toclink3={Toclink3}
            isMuted={isMuted}
            toggleMute={toggleMute}
            completed={completed}
            captions={[
              { startTime: 0, endTime: 2, text: "You have completed the lesson. Let’s summarize!"},
              { startTime: 2, endTime: 11, text: "You’ve successfully learned the features and functions of a clamp meter and how to use a clamp meter to measure amperage in a vehicle’s starting system." },
              { startTime: 11, endTime: 17, text: "You explored the parts of the clamp meter, including the clamp, and function switch knob." },
              { startTime: 17, endTime: 22, text: "Each part plays a critical role in taking accurate amperage measurements." },
              { startTime: 22, endTime: 33, text: "You learned about safe practices when measuring amperage in a vehicle’s starting system by clamping the meter around the positive battery cable and taking accurate readings." },
              { startTime: 33, endTime: 40, text: "You’re now equipped with the knowledge to use a clamp meter to take measurements in vehicles safely and effectively." },
              { startTime: 40, endTime: 44, text: "You can now exit by clicking the close button." },
              ]}
            videoSrc1={videoSrc1}
            onVideoEnd={() => handleVideoEnd(2)}
          />
        ) : (
          <VideoPlayer1
            decreaseCount={decreaseCount}
            Toclink1={Toclink1}
            Toclink2={Toclink2}
            handleFullscreen={handleFullscreen}
            Toclink3={Toclink3}
            videoSrc2={videoSrc2} 
            completed={completed}
            isMuted={isMuted}
            toggleMute={toggleMute}
            audioDescriptions={audioDescriptions}
            captions={[
                { startTime: 0, endTime: 2, text: "You have completed the lesson. Let’s summarize!" },
                { startTime: 2, endTime: 11, text: "You’ve successfully learned the features and functions of a clamp meter and how to use a clamp meter to measure amperage in a vehicle’s starting system." },
                { startTime: 11, endTime: 17, text: "You explored the parts of the clamp meter, including the clamp, and function switch knob." },
                { startTime: 17, endTime: 22, text: "Each part plays a critical role in taking accurate amperage measurements." },
                { startTime: 22, endTime: 33, text: "You learned about safe practices when measuring amperage in a vehicle’s starting system by clamping the meter around the positive battery cable and taking accurate readings." },
                { startTime: 33, endTime: 40, text: "You’re now equipped with the knowledge to use a clamp meter to take measurements in vehicles safely and effectively." },
                { startTime: 40, endTime: 44, text: "You can now exit by clicking the close button." },
                ]}
            onVideoEnd={() => handleVideoEnd(3)}
          />
        )}
      </div>
      </div>
  );
};

export default App;
